import React from "react";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { setRegionIcon } from "../../../components/RegionCard/region-card";
import "./styles.scss";

interface PersonCardProps {
  person: Person;
}

export interface Person {
  name: string;
  title: string;
  image: string;
  region: string;
  country?: string;
  logo?: string;
  flag?: string;
  organization: string;
  linkedIn?: string;
}

export const PersonCard = (props: PersonCardProps): JSX.Element => {
  const { person } = props;
  return (
    <div className="pc">
      <div className="pc__header">
        {person.linkedIn && (
          <a
            href={person.linkedIn}
            target="_blank"
            rel="noreferrer"
            className="linkedIn"
          >
            <LinkedInIcon />
          </a>
        )}
        <img src={person.image} alt={`people-${person.name}`} />
        <div className="pc__header-name">
          <h6>{person.name}</h6>
          <p>
            {person.title},<br />
            {person.organization}
          </p>
        </div>
      </div>
      <div className="pc__meta">
        <div className="pc__meta-location">
          <div className="pc__meta-location-region">
            <img
              src={setRegionIcon(person.region)}
              alt={`region-${person.name}`}
            />
            <p>{person.region}</p>
          </div>
          {person.country && (
            <div className="pc__meta-location-country">
              {person.flag ? (
                <img src={person.flag} alt={`country-${person.name}`} />
              ) : (
                <div className="country-indicator" />
              )}
              <p>{person.country}</p>
            </div>
          )}
        </div>
        <div className="pc__meta-logo">
          {person.logo && <img src={person.logo} alt={`logo-${person.name}`} />}
        </div>
      </div>
    </div>
  );
};
